import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["card", "providerField", "nameField", "customIdField", "hints"];
  static values = { selected: String };

  connect() {
    const existing = this.providerFieldTarget.value;
    if (existing) {
      this.selectedValue = existing;
      this.applySelection(existing);
    }
  }

  select(event) {
    const provider = event.currentTarget.dataset.provider;

    if (this.selectedValue === provider) {
      this.selectedValue = "";
      this.clearSelection();
      return;
    }

    this.selectedValue = provider;
    this.providerFieldTarget.value = provider;
    this.applySelection(provider);

    const presets = {
      github: { name: "GitHub Webhooks", customId: "github-webhooks" },
      stripe: { name: "Stripe Webhooks", customId: "stripe-webhooks" },
      shopify: { name: "Shopify Webhooks", customId: "shopify-webhooks" },
      twilio: { name: "Twilio Webhooks", customId: "twilio-webhooks" },
    };

    const preset = presets[provider];
    if (preset && this.hasNameFieldTarget && !this.nameFieldTarget.value) {
      this.nameFieldTarget.value = preset.name;
    }
    if (preset && this.hasCustomIdFieldTarget && !this.customIdFieldTarget.value) {
      this.customIdFieldTarget.value = preset.customId;
      this.customIdFieldTarget.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  applySelection(provider) {
    this.cardTargets.forEach((card) => {
      const isSelected = card.dataset.provider === provider;
      card.classList.toggle("ring-2", isSelected);
      card.classList.toggle("ring-indigo-500", isSelected);
      card.classList.toggle("border-indigo-500", isSelected);
      card.classList.toggle("border-gray-200", !isSelected);
    });

    this.hintsTargets.forEach((hint) => {
      hint.classList.toggle("hidden", hint.dataset.provider !== provider);
    });
  }

  clearSelection() {
    this.providerFieldTarget.value = "";
    this.cardTargets.forEach((card) => {
      card.classList.remove("ring-2", "ring-indigo-500", "border-indigo-500");
      card.classList.add("border-gray-200");
    });
    this.hintsTargets.forEach((hint) => hint.classList.add("hidden"));
  }
}
